import { render, staticRenderFns } from "./ConfigTextPlayer.vue?vue&type=template&id=d4e9f9e0"
import script from "./ConfigTextPlayer.vue?vue&type=script&lang=js"
export * from "./ConfigTextPlayer.vue?vue&type=script&lang=js"
import style0 from "./ConfigTextPlayer.vue?vue&type=style&index=0&id=d4e9f9e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCheckbox,VCol,VDivider,VIcon,VRow,VSlider,VTextField})
